// Utility functions for asset-mapping

/**
 * Truncate text to a max length, appending dots if needed
 */
export function truncateText(text, maxLength = 30) {
  if (!text) return "";
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + "...........................";
}

/**
 * Filter documents by assetId from emailData
 */
const docAsstMap = (assetId, emailData, assetListData) => {
  const asset = assetListData.find((asset) => asset.id === assetId);
  if (!asset) return [];
  const filteredDocs = {
    assetId: assetId,
    asset: asset.asset,
    documents: [],
  };
  emailData.emailProcessing.forEach((processing) => {
    processing.emailDocuments?.forEach((doc) => {
      if (doc.assetIds?.includes(assetId)) {
        filteredDocs.documents.push({
          ...doc,
          subject: processing.subject,
          receivedAt: processing.receivedAt,
        });
      }
    });
  });
  return filteredDocs;
};

export function filterDocumentsByAsset(assetId, emailData, assetListData) {
  if (!emailData?.emailProcessing) return [];

  if (assetId !== "all") {
    const result = docAsstMap(assetId, emailData, assetListData);
    return [result];
  } else {
    const allDocs = assetListData?.map(({ id }) => {
      const result = docAsstMap(id, emailData, assetListData);
      return result;
    });
    return allDocs;
  }
}
